import React from 'react';
import {createPortal} from 'react-dom';

export default function ArchiX6ConnectionTypePicker({picker, modeler, onClose}) {
	if (!picker) return null;

	const items = modeler?.getConnectionTypesForSource?.(picker.nodeId) ?? [];

	return createPortal(
		<div
			role="menu"
			className="archi-x6-connection-type-picker"
			style={{
				position: 'fixed',
				left: picker.x,
				top: picker.y,
				zIndex: 10000,
				minWidth: 160,
				maxHeight: 320,
				overflowY: 'auto',
				background: '#fff',
				border: '1px solid #d9d9d9',
				borderRadius: 6,
				boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
				padding: '4px 0',
				touchAction: 'none',
			}}
			onClick={e => e.stopPropagation()}
		>
			<div
				style={{
					padding: '4px 12px',
					fontSize: 11,
					color: '#8c8c8c',
					borderBottom: '1px solid #f0f0f0',
				}}
			>
				Тип связи → нажмите и тяните к элементу
			</div>
			{items.map(({type, label}) => (
				<button
					key={type}
					type="button"
					style={{
						display: 'block',
						width: '100%',
						padding: '6px 12px',
						textAlign: 'left',
						border: 'none',
						background: 'none',
						cursor: 'pointer',
						fontSize: 13,
					}}
					onPointerDown={e => {
						e.preventDefault();
						e.stopPropagation();
						modeler?.startConnectionDrag?.(
							picker.nodeId,
							type,
							{clientX: e.clientX, clientY: e.clientY},
							{pointerId: e.pointerId}
						);
						onClose?.();
					}}
				>
					{label}
				</button>
			))}
		</div>,
		document.body
	);
}
